import {registerInitializer} from "../shared/utils";

export const initializeReferenceHandler = () => {
  $('.parallax-reference-window').each(function(){
    $(this).parallax({imageSrc: $(this).data("srcurl")});
  });
};

registerInitializer(initializeReferenceHandler);
